import { AxiosError } from "axios";

import { ApiError } from "./client";

/**
 * Best-effort human-readable message from a thrown API/Axios error, falling
 * back to `fallback`. Prefers the canonical `{error:{message}}` envelope (via
 * `ApiError`), then a legacy `{detail}` body, else the fallback.
 *
 * Single source of truth — was copy-pasted into every staff form/panel.
 */
export function extractErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiError) return err.message;
  if (err instanceof AxiosError) {
    const data = err.response?.data as { detail?: string } | undefined;
    if (data?.detail) return data.detail;
  }
  return fallback;
}
